"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.object.keys");
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.reflect.has");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _MultiLanguageInp = _interopRequireDefault(require("@/components/MultiLanguageInp"));
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _lodash = require("lodash");
var _trends = require("@/api/cont/trends");
var _admin = require("@/api/admin");
var _config = require("@/api/config");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    MultiLanguageInp: _MultiLanguageInp.default
  },
  data: function data() {
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      memberStatus: false,
      tabsAll: [],
      languageTranslation: false,
      rules: {},
      inpData: {},
      lang: 'zh',
      inpShow: '',
      tabsOne: [{
        name: '国内站',
        label: '国内站',
        id: '0'
      }, {
        name: '海外站',
        label: '海外站',
        id: '1'
      }],
      activeNameOne: '0',
      tabsTwo: [{
        name: '标准版',
        label: '标准版',
        id: '0'
      }, {
        name: '高级版',
        label: '高级版',
        id: '1'
      }, {
        name: '尊享版',
        label: '尊享版',
        id: '2'
      }],
      activeNameTwo: '0',
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 20,
        sort: 'add_time',
        order: 'desc'
      },
      total: 0,
      oldIndex: null,
      newIndex: null,
      list: [],
      currentRow: {},
      nameLang: {},
      langList: [],
      currentIndex: null
    };
  },
  computed: {},
  mounted: function mounted() {
    // this.init()
    // this.getLangList()
    // this.getList()
  },
  methods: {
    open: function open(introInfo) {
      var _this2 = this;
      console.log('introInfo', introInfo);
      this.memberStatus = true;
      this.$nextTick(function () {
        _this2.init();
      });
      if (introInfo) {
        this.list = JSON.parse(introInfo);
      } else {
        this.list = [];
      }
      console.log('this', this.list);
      this.getLangList();
    },
    // 获取列表
    getList: function getList() {
      var _this3 = this;
      var params = {
        oversea: this.activeNameOne * 1,
        vipLevel: this.activeNameTwo * 1
      };
      (0, _config.getListVip)(params).then(function (res) {
        if (res.data.errno == 0) {
          _this3.listLoading = false;
          _this3.list = res.data.data;
          _this3.list.forEach(function (item) {
            _this3.$set(item, 'edit', false);
          });
        }
      });
    },
    // 获取语言种类
    getLangList: function getLangList() {
      var _this4 = this;
      (0, _admin.getLangCode)().then(function (res) {
        console.log('11');
        _this4.langList = res.data.data.list.map(function (item) {
          return item.label;
        });
      });
    },
    onLanguageVisible: function () {
      var _onLanguageVisible = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(row) {
        var _this5 = this;
        var res, item;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (row.edit) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.tip = false;
              this.inpData = JSON.parse(row.intro);
              this.currentRow = row;
              this.getInpShowData();
              _context.n = 2;
              return (0, _admin.getLangCode)();
            case 2:
              res = _context.v;
              // this.nameLang = {
              //   zh: '',
              //   en: '',
              //   es: ''
              // }
              res.data.data && res.data.data.list ? res.data.data.list.forEach(function (item) {
                _this5.$set(_this5.nameLang, item.label, '');
                _this5.rules[item.label] = _this5.rulesInp;
              }) : this.nameLang = {};
              // Object.keys(this.nameLang).forEach(key => {
              //   this.rules[key] = this.rulesInp
              // })
              for (item in this.inpData) {
                if (Boolean(this.inpData[item]) && Reflect.has(this.nameLang, item)) {
                  this.nameLang[item] = this.inpData[item];
                }
              }
              // this.nameLang['en'] = this.inpShow
              if (this.nameLang[this.lang] !== this.inpShow) {
                this.nameLang['zh'] = this.inpShow;
              }
              this.languageTranslation = true;
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onLanguageVisible(_x) {
        return _onLanguageVisible.apply(this, arguments);
      }
      return onLanguageVisible;
    }(),
    getInpShowData: function getInpShowData() {
      if (Object.getOwnPropertyNames(this.inpData).length !== 0) {
        for (var item in this.inpData) {
          if (this.lang === item.substring(0, 2)) {
            this.inpShow = this.inpData[item];
            return;
          }
        }
        this.inpShow = '';
      }
    },
    handleLanguage: function handleLanguage() {
      var _this6 = this;
      console.log(this.nameLang, 'nameh');
      this.$refs.nameLang.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(valid) {
          return (0, _regenerator2.default)().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (valid) {
                  _this6.languageTranslation = false;
                  console.log('this.currentRow', _this6.currentRow);
                  // this.list.forEach(item=>{
                  //   if(item.id==this.currentRow.id){
                  //     item.intro=JSON.stringify(this.nameLang)
                  //   }
                  // })
                  _this6.list[_this6.currentIndex].intro = JSON.stringify(_this6.nameLang);
                }
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    trans: function trans() {
      var _this7 = this;
      var key = '';
      if (this.nameLang['zh']) {
        key = this.nameLang['zh'];
      } else {
        for (var keyName in this.nameLang) {
          if (this.nameLang.hasOwnProperty(keyName)) {
            if (this.nameLang[keyName]) {
              key = this.nameLang[keyName];
              break; // 中断循环
            }
          }
        }
      }
      if (!key) return;
      var params = {
        key: key
      };
      (0, _trends.languageTranslation)(params).then(function (res) {
        if (res.code === '0' && res.data && Object.keys(res.data).length !== 0) {
          for (var _keyName in _this7.nameLang) {
            if (_this7.nameLang.hasOwnProperty(_keyName)) {
              _this7.$set(_this7.nameLang, _keyName, res.data[_keyName]);
            }
          }
        }
      });
    },
    inputChange: function inputChange(value, row) {
      var contObj = JSON.parse(row.intro);
      contObj[this.lang] = value;
      row.intro = JSON.stringify(contObj);
    },
    // 切换一级类目
    handleClickOne: function handleClickOne(tab, event) {
      this.getList();
    },
    // 切换二级类目
    handleClickTwo: function handleClickTwo(tab, event) {
      this.getList();
    },
    // 启用状态
    onEnable: function onEnable(value, row) {
      if (!row.id) return;
      var params = {
        oversea: this.activeNameOne * 1,
        vipLevel: this.activeNameTwo * 1,
        id: row.id,
        status: value,
        enabled: value == 1 ? true : false
      };
      (0, _config.setEnabledVip)(params).then(function (res) {});
    },
    add: function add() {
      this.list.unshift({
        edit: true,
        status: 0,
        intro: "{}",
        id: this.list.length + 1
      });
    },
    // 编辑
    edit: function edit(row, index) {
      row.edit = true;
      this.currentIndex = index;
    },
    onBlur: function onBlur(row) {
      this.onLanguageVisible(row);
    },
    save: function save(row) {
      console.log('row', row, this.list);
      // const isValid = this.validateIntro(row.intro);
      // if(!isValid){
      //  return this.onLanguageVisible(row)
      // }
      // const params={
      //   id:row.id || '',
      //   intro:row.intro,
      //   oversea:this.activeNameOne*1,
      //   status:row.status,
      //   vipLevel:this.activeNameTwo*1
      // }
      // editVip(params).then(res=>{
      //   console.log('res',res);
      //   if(row.id){
      //     this.$message.success('编辑成功')
      //   }else{
      //     this.$message.success('新增成功')
      //     this.getList()
      //   }

      // })
      row.edit = false;
      this.$emit('saveList', this.list);
    },
    deleteVip: function deleteVip(row, index) {
      console.log('index', index);
      this.list.splice(index, 1);
      this.$emit('saveList', this.list);

      // this.list=[]
      // this.$emit('saveList', this.list)
      // const params={
      //   id:row.id,
      //   oversea:this.activeNameOne*1,
      //   vipLevel:this.activeNameTwo*1
      // }
      // deleteVip(params).then(res=>{
      //   if(res.data.errno==0){
      //     this.$message.success('删除成功')
      //     this.getList()
      //   }

      // })
    },
    validateIntro: function validateIntro(intro) {
      // 解析 intro 字符串为对象
      var introObj = JSON.parse(intro);

      // 检查所有 key 是否存在，并且对应的值不为空
      var _iterator = (0, _createForOfIteratorHelper2.default)(this.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          if (!introObj.hasOwnProperty(key) || !introObj[key]) {
            return false; // 如果某个 key 不存在或值为空，返回 false
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return true;
    },
    init: function init() {
      // 1. 获取拖拽元素的父元素
      // 因为使用的element的table 所以可直接获取tbody
      var el = document.querySelector(".info .el-table__body-wrapper tbody");
      var _this = this;
      // 2. 创建并配置相关参数
      var sortable = new _sortablejs.default(el, {
        // 此处进行配置 及 回调函数的使用
        handle: '.handle_move',
        // css选择器的字符串 若设置该值，则表示只有按住拖动手柄才能使列表单元进行拖动
        draggable: '.el-table__row',
        // 允许拖拽的项目类名
        // 因为拖拽过程中不尽兴位置调整，所以就要记录拖拽行初始位置以及目标位置
        // 拖拽中 回调函数
        onMove: function onMove(customEvent) {
          // 禁止在拖拽过程中交换位置
          // 可将初始位置及目标位置进行记录
          _this.oldIndex = customEvent.dragged.rowIndex; //  初始位置
          _this.newIndex = customEvent.related.rowIndex; // 目标位置
          console.log(_this.oldIndex, _this.newIndex, 's');
          return false;
        },
        // 拖拽结束，调整位置
        onEnd: function onEnd() {
          // 在拖拽结束后，获取初始及目标位置
          var newIndex = _this.newIndex,
            oldIndex = _this.oldIndex;
          var currRow = _this.list.splice(oldIndex, 1)[0];
          _this.list.splice(newIndex, 0, currRow);
          // // 拖拽完成，初始位置及目标位置重置
          _this.newIndex = null;
          _this.oldIndex = null;
          // const list=_this.list.map(item=>item.id)
          _this.$emit('saveList', _this.list);
          // const params={
          //   oversea:_this.activeNameOne*1,
          //   vipLevel:_this.activeNameTwo*1,
          //   sortIds:list
          // }
          // sortVip(params).then(res=>{
          //   console.log('aa',res);

          // })
        }
      });
    }
  }
};